module.exports = __webpack_public_path__ + "img/7.edc18572.jpg";